import React, { Component } from 'react'
import { Drawer, Card, Button, Icon, Tag, Table, notification } from 'antd'
import { RowTable } from '../article/articleView/RowTable'
import { connect } from 'react-redux'
import EditAbstractSubmission from '../../containers/onlineAbstract/editAbstractSubmission'
import { FetchSingleOnlineAbstractAction } from './actions'
import ReactHtmlParser from 'react-html-parser'

class AbstractDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      visibleEdit: false,
      abstractData: props.data || {}
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data && prevProps.data._id !== this.props.data._id) {
      this.setState({ abstractData: this.props.data || {} })
    }
  }
  loadSingleAbstract = async () => {
    const { dispatch } = this.props;
    const currentId = this.state.abstractData._id;

    if (!currentId) return;

    try {
      this.setState({ loading: true });
      let response = await dispatch(FetchSingleOnlineAbstractAction(currentId));

      if (response && response.success) {
        this.setState({ abstractData: response.data });
      }
    } catch (error) {
      console.error("Failed to refresh abstract", error);
    } finally {
      this.setState({ loading: false });
    }
  }
  handleEdit = () => {
    this.setState({
      visibleEdit: true
    })
  }

  render() {
    const { visible, data, onClose, callBackReload } = this.props
    const selected = this.state.abstractData || {}
    // const selected = data || {}

    // Format attachments for table display
    let attachmentArr = [
      {
        abstractFile: selected.abstractFile,
        copyrightForm: selected.copyrightForm,
        supportingFile: selected.supportingFile
      }
    ]

    // const AttachmentColumns = [
    //   {
    //     title: 'Abstract File',
    //     key: 'abstractFile',
    //     dataIndex: 'abstractFile',
    //     render: item => {
    //       return item && item.fileName ? (
    //         <a href={item.path} target="_blank" rel="noreferrer">{item.fileName}</a>
    //       ) : 'N/A'
    //     }
    //   },
    //   {
    //     title: 'Copyright Form',
    //     key: 'copyrightForm',
    //     dataIndex: 'copyrightForm',
    //     render: item => {
    //       return item && item.fileName ? (
    //         <a href={item.path} target="_blank" rel="noreferrer">{item.fileName}</a>
    //       ) : 'N/A'
    //     }
    //   },
    //   {
    //     title: 'Supporting File',
    //     key: 'supportingFile',
    //     dataIndex: 'supportingFile',
    //     render: item => {
    //       return item && item.fileName ? (
    //         <a href={item.path} target="_blank" rel="noreferrer">{item.fileName}</a>
    //       ) : 'N/A'
    //     }
    //   }
    // ]
    const AttachmentColumns = [
      {
        title: 'Abstract File',
        key: 'abstractFile',
        dataIndex: 'abstractFile',
        render: item => {
          return item && item.fileName ? (
            <Button
              type='link'
              size='small'
              icon='eye'
              onClick={() => window.open(item.path, '_blank')}
              style={{ padding: 0 }}
            >
              {item.fileName}
            </Button>
          ) : 'N/A'
        }
      },
      {
        title: 'Copyright Form',
        key: 'copyrightForm',
        dataIndex: 'copyrightForm',
        render: item => {
          return item && item.fileName ? (
            <Button
              type='link'
              size='small'
              icon='eye'
              onClick={() => window.open(item.path, '_blank')}
              style={{ padding: 0 }}
            >
              {item.fileName}
            </Button>
          ) : 'N/A'
        }
      },
      {
        title: 'Supporting File',
        key: 'supportingFile',
        dataIndex: 'supportingFile',
        render: item => {
          return item && item.fileName ? (
            <Button
              type='link'
              size='small'
              icon='eye'
              onClick={() => window.open(item.path, '_blank')}
              style={{ padding: 0 }}
            >
              {item.fileName}
            </Button>
          ) : 'N/A'
        }
      }
    ]
    return (
      <>
        <Drawer
          visible={visible}
          width={'86%'}
          placement='right'
          onClose={onClose}
          title={
            <div>
              Abstract Details
              <a
                className={'linkIcon'}
                onClick={this.handleEdit}
                style={{ marginLeft: '15px' }}>
                <Icon type={'edit'} />
              </a>
            </div>
          }>
          <Card>
            {/* Basic Information - using RowTable */}
            <div className={'tableBox striped'}>
              {/*<RowTable title={'Abstract ID'} value={selected._id || 'N/A'} />*/}
              <RowTable title={'Abstract No'} value={selected.onlineAbstractNo || 'N/A'} />
              <RowTable title={'Abstract Title'} value={selected.titleOfAbstract || 'N/A'} />
              {/*<RowTable*/}
              {/*  title={'Journals'}*/}
              {/*  value={*/}
              {/*    <div>*/}
              {/*      {selected.journal && selected.journal.name ? selected.journal.name : ''}*/}
              {/*    </div>*/}
              {/*  }*/}
              {/*/>*/}
              <RowTable
                title={selected.eventId ? 'Event' : 'Journal'}
                value={
                  selected.eventId
                    ? (selected.eventId.eventName || selected.eventId.name || selected.eventId.title || 'Unnamed Event')
                    : (selected.journal && selected.journal.name ? selected.journal.name : 'N/A')
                }
              />
              <RowTable title={'Country'} value={selected.country || 'N/A'} />
              <RowTable title={'Issue Type'} value={selected.issueType || 'N/A'} />
              <RowTable title={'Research Area'} value={selected.researchArea || 'N/A'} />
              <RowTable title={'Speaker Note'} value={selected.speakerNote || 'N/A'} />
              {/*<RowTable*/}
              {/*  title={'Abstract'}*/}
              {/*  value={*/}
              {/*    <div style={{ width: '75%', whiteSpace: 'pre-wrap' }}>*/}
              {/*      {selected.abstract || 'N/A'}*/}
              {/*    </div>*/}
              {/*  }*/}
              {/*/>*/}
              <RowTable
                title={'Abstract'}
                value={
                  <div>
                    {selected.abstract ? ReactHtmlParser(selected.abstract) : 'N/A'}
                  </div>
                }
              />
              <RowTable
                title={'Keywords'}
                value={
                  <div>
                    {(selected.keywords || []).map((k, i) => (
                      <Tag key={i} color='blue'>{k}</Tag>
                    ))}
                  </div>
                }
              />
            </div>

            <br />

            {/* Author Details - Primary Author */}
            {selected.authorName && (
              <>
                <h3>Author Details</h3>
                <Table
                  columns={[
                    { title: 'Name', key: 'name', dataIndex: 'name', width: '17%' },
                    { title: 'Email', key: 'email', dataIndex: 'email', width: '17%' },
                    {
                      title: 'Institute Affiliated',
                      key: 'instituteAffiliated',
                      dataIndex: 'instituteAffiliated',
                      width: '17%'
                    },
                    { title: 'Designation', key: 'designation', dataIndex: 'designation', width: '16%' },
                    { title: 'Country', key: 'country', dataIndex: 'country', width: '16%' },
                    { title: 'ORCID ID', key: 'orcidId', dataIndex: 'orcidId', width: '17%' }
                  ]}
                  dataSource={[{
                    name: selected.authorName,
                    instituteAffiliated: selected.institution,
                    designation: selected.designation,
                    email: selected.email,
                    country: selected.country,
                    orcidId: selected.orcidId
                  }]}
                  size={'small'}
                  pagination={false}
                  bordered
                />
                <br />
              </>
            )}

            {/* Co-Authors - Only if exists */}
            {selected.coAuthors && selected.coAuthors.length > 0 && (
              <>
                <h3>Co-Authors</h3>
                <Table
                  columns={[
                    { title: 'Name', key: 'name', dataIndex: 'name', width: '20%' },
                    { title: 'Email', key: 'email', dataIndex: 'email', width: '20%' },
                    { title: 'Institute Affiliated', key: 'affiliation', dataIndex: 'affiliation', width: '20%' },
                    { title: 'Country', key: 'country', dataIndex: 'country', width: '20%' },
                    { title: 'ORCID ID', key: 'orcidId', dataIndex: 'orcidId', width: '20%' }
                  ]}
                  dataSource={selected.coAuthors}
                  size={'small'}
                  pagination={false}
                  bordered
                />
                <br />
              </>
            )}

            {/* Attachments Table */}
            <h3>Attachments</h3>
            <Table
              columns={AttachmentColumns}
              dataSource={attachmentArr}
              size={'small'}
              pagination={false}
              bordered
            />
          </Card>
        </Drawer>
        {/*{this.state.visibleEdit && (*/}
        {/*  <EditAbstractSubmission*/}
        {/*    visible={this.state.visibleEdit}*/}
        {/*    onClose={() => this.setState({ visibleEdit: false })}*/}
        {/*    article={selected}*/}
        {/*    reload={callBackReload}*/}
        {/*  />*/}
        {/*)}*/}
        {this.state.visibleEdit && (
          <EditAbstractSubmission
            visible={this.state.visibleEdit}
            onClose={() => this.setState({ visibleEdit: false })}
            article={selected}
            reload={() => {
              if (callBackReload) callBackReload();
              this.loadSingleAbstract();
            }}
          />
        )}
      </>

    )

  }
}

// export default AbstractDrawer
export default connect()(AbstractDrawer)
